function toPascalCase(obj: Record<string, any>): Record<string, any> {
  console.log(JSON.stringify(obj));
  const convertedObj: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    const pascalKey = key.replace(/(^.|[A-Z])/g, (letter) => letter.toUpperCase()); // Adjust regex if necessary
    convertedObj[pascalKey] = obj[key];
  });
  return convertedObj;
}
export default toPascalCase;